export const SET_USER_ROLE = "SET_USER_ROLE ";
export const GET_USER_ROLE = "GET_USER_ROLE ";
